import React from 'react';
import { Button, Carousel, Typography } from 'antd';
import "App.css";


type Props = {
	data: NodeRequire[],
	width?: string,
	height?:string,
};


export const ImagePlayer: React.FC<Props> = (props) => {

	const contentStyle: React.CSSProperties = {
		maxWidth: '90vw',
		maxHeight: '50vw',
		width: props.width ? props.width : '90vw',
		height: props.height ? props.height : '50vh',
		color: 'white',
		lineHeight: '160px',
		textAlign: 'center',
		background: '#000000',
		margin: "auto",
		padding: 0,
		borderRadius: 20,
		overflow: 'hidden',
		position: 'relative',
	};
	
	return (
		<Carousel className="shadow" autoplay={true} autoplaySpeed={1000} style={contentStyle}>
			{props.data.map((item, index) => (
				<div key={index} >
					<img src={String(item)} style={{width: "100%"}} />
				</div>
			))}
		</Carousel>
	);};

